"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSizeByFontSize = exports.getFontSizeByIconSize = exports.getColorByToken = exports.getClassNames = void 0;
var _system = require("@mui/system");
var _SvgIcon = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _constants = require("./constants");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var getColorByToken = exports.getColorByToken = function getColorByToken(kind, color) {
  if (kind) {
    return _constants.KIND_STYLES[kind];
  }
  if (color) {
    return _constants.COLOR_STYLES[color];
  }
  return null;
};
var getSizeByFontSize = exports.getSizeByFontSize = function getSizeByFontSize(fontSize) {
  return fontSize === 'default' ? 'medium' : fontSize;
};
var getFontSizeByIconSize = exports.getFontSizeByIconSize = function getFontSizeByIconSize(size) {
  return _constants.SIZE_STYLES[size] || _constants.SIZE_STYLES.medium;
};
var getClassNames = exports.getClassNames = function getClassNames(iconSize) {
  return "".concat(_constants.CLASSNAME_BASE, " ").concat(_constants.CLASSNAME_BASE, "--").concat(iconSize || 'medium');
};